export default {
	updateAnalysisReportData(state, payload) {
		state.AnalysisReportData = payload;
	},

	updateLatestAnalysisReportHistory(state, payload) {
		state.LatestAnalysisReportHistory = payload;
	},

	updateLastRequestFilter(state, filterData) {
		state.LastRequestFilter = filterData;
	}
};
